// src/lib/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, key } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "PUSH" || navigationType === "REPLACE") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname, key, navigationType]);
  useEffect(() => {
    const handleSameLinkClick = (e) => {
      const target = e.target.closest("a");
      if (target && target.href === window.location.href) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };
    document.addEventListener("click", handleSameLinkClick);
    return () => document.removeEventListener("click", handleSameLinkClick);
  }, []);

  return null;
};

export default ScrollToTop;
